"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getButtonSpacing = void 0;
var _memoize = require("./memoize");
const defaultSpacing = 4;
const flushSpacing = 2;
const getCacheKey = ({
  compact,
  flush,
  startIcon,
  endIcon
}) => {
  return `${compact}-${flush}-${startIcon}-${endIcon}`;
};
const getButtonSpacing = (0, _memoize.memoize)(function getButtonSpacing({
  compact,
  flush
}) {
  // Web Button styles are pulled from here
  const spacing = {
    start: flush || compact ? flushSpacing : defaultSpacing,
    end: flush || compact ? flushSpacing : defaultSpacing
  };
  return spacing;
}, getCacheKey);
exports.getButtonSpacing = getButtonSpacing;